import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'db-migrate-website-footer',
    templateUrl: './migrate-website-footer.component.html',
    styleUrls: ['./migrate-website-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MigrateWebsiteFooterComponent implements OnInit {

  @Input() loading = false;
  @Input() showManualMigration = false;
  @Input() hostedWebsitesCount: number;
  @Input() hostedWebsitesLimit: number;
  @Output() readonly submitted = new EventEmitter<void>();
  @Output() readonly manualRequested = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

}
